<template>
  <page-edicion v-if="this.ready" :title="`Módulo ${modulo.nombre}`">
    <formulario-planes-horas
      :modulo-plan-horas-normalizados="horasNormalizadas"
      :planes="planes"
      @submit="actualizar"
    />
  </page-edicion>
</template>

<script>
import FormularioPlanesHoras from "./FormularioPlanesHoras.vue";
import * as modulosApi from "@/services/modulos.js";
import planesApi from "@/services/planes.js";

function completarHorasNormalizados(id, planes, modulosPlanHoras) {
  for (var plan of planes) {
    if (!modulosPlanHoras[plan.id]) {
      modulosPlanHoras[plan.id] = {
        moduloId: id,
        numHorasCapacitacion: 0,
        numHorasConsultoria: 0,
      };
    }
  }
  return modulosPlanHoras;
}
export default {
  components: { FormularioPlanesHoras },
  data() {
    return {
      ready: false,
      moduloId: 0,
      modulo: {},
      planes: [],
      horas: [],
      horasNormalizadas: {},
    };
  },
  async mounted() {
    this.moduloId = this.$route.params.id;
    await Promise.all([this.cargar(this.moduloId), this.listarPlanes()]);
    this.horasNormalizadas = completarHorasNormalizados(this.moduloId, this.planes, this.horas);
    this.ready = true;
  },
  methods: {
    async cargar(moduloId) {
      this.modulo = await modulosApi.cargar(moduloId);
      this.horas = await modulosApi.cargarHoras(moduloId);
    },
    async actualizar() {
      await modulosApi.actualizarHoras(this.moduloId, this.horasNormalizadas);
      this.$router.push({ path: "/modulos" });
    },
    async listarPlanes() {
      this.planes = await planesApi.listar();
    },
  },
};
</script>
